import { Icon } from "@circle-react-shared/Icon";
import { Typography } from "@circle-react-uikit/Typography";
import type { CommunityMember } from "@circle-react/types";

import { t } from "@/i18n-js/instance";
import { UserImage } from "@/react/components/SettingsApp/CompassCompat/UserImage";

import { getTimeAgo } from "../utils";

const i18nRoot = "settings.moderation.review_flagged_content_modal";

interface ReporterInfoProps {
  profanity_filter_matches?: string;
  reported_at?: string;
  reported_reason_type?: string;
  reporter?: CommunityMember;
}

export const ReporterInfo = ({
  profanity_filter_matches = "",
  reported_at = "",
  reported_reason_type = "",
  reporter,
}: ReporterInfoProps) => {
  const reporterName = reporter?.name ?? "";

  return reporter ? (
    <div className="flex items-center gap-4">
      <UserImage name={reporterName} src={reporter.avatar_url} size="8" />
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-1">
          <Typography.LabelSm weight="semibold">
            {reporterName}
          </Typography.LabelSm>
          <Typography.LabelSm color="text-dark">
            {t([i18nRoot, "reason_labels.reported_for"])}
          </Typography.LabelSm>
          <Typography.LabelSm
            color="text-dark"
            weight="semibold"
            data-testid="report-reason-type"
          >
            {t([i18nRoot, "report_reasons", reported_reason_type])}
          </Typography.LabelSm>
        </div>
        <Typography.LabelXs color="text-dark">
          {getTimeAgo(reported_at)}
        </Typography.LabelXs>
      </div>
    </div>
  ) : (
    <div className="flex items-center gap-4">
      <div className="flex size-8 items-center justify-center rounded-full bg-black">
        <Icon type="lightning" size={16} className="text-white" />
      </div>
      <div className="flex flex-col gap-1">
        <div className="flex items-center gap-1">
          <Typography.LabelSm
            weight="semibold"
            data-testid="report-reason-type"
          >
            {t([i18nRoot, "automatically_flagged"])}
          </Typography.LabelSm>
          {profanity_filter_matches ? (
            <Typography.LabelSm color="text-dark">
              {t([i18nRoot, "reason_labels.profanity_filter"])}
            </Typography.LabelSm>
          ) : (
            <Typography.LabelSm color="text-dark">
              {t([i18nRoot, "reason_labels.for_approval"])}
            </Typography.LabelSm>
          )}
        </div>
        <Typography.LabelXs color="text-dark">
          {getTimeAgo(reported_at)}
        </Typography.LabelXs>
      </div>
    </div>
  );
};
